import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaEye, FaVideo, FaHistory } from 'react-icons/fa';
import { CCTVCamera } from '../utils/cctvTypes';
import { formatTimestamp } from '../utils/cctvApiService';

interface CCTVCameraTableProps {
  cameras: CCTVCamera[];
  onCameraClick: (camera: CCTVCamera) => void;
}

const CCTVCameraTable: React.FC<CCTVCameraTableProps> = ({ cameras, onCameraClick }) => {
  const navigate = useNavigate();

  if (cameras.length === 0) {
    return (
      <div className="no-data">
        <div className="no-data-icon"><FaVideo /></div>
        <h3>No cameras found</h3>
        <p>No CCTV cameras available for the selected filters.</p>
      </div>
    );
  }

  return (
    <div className="camera-table-container">
      <table className="camera-table">
        <thead>
          <tr>
            <th>Camera Name</th>
            <th>Station</th>
            <th>Zone</th>
            <th>Division</th>
            <th>Status</th>
            <th>Last Updated</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {cameras.map((camera) => (
            <tr key={camera.id} onClick={() => onCameraClick(camera)}>
              <td className="name-cell">
                <FaVideo className="camera-icon" />
                <span>{camera.name}</span>
              </td>
              <td>{camera.station}</td>
              <td>{camera.zone}</td>
              <td>{camera.division}</td>
              <td>
                <span className={`status-badge ${camera.status}`}>
                  {camera.status === 'active' ? 'Working' : 'Non-Working'}
                </span>
              </td>
              <td>{formatTimestamp(camera.lastActivity)}</td>
              <td>
                <div className="action-buttons">
                  <button
                    className="action-btn detail"
                    onClick={(e) => {
                      e.stopPropagation();
                      onCameraClick(camera);
                    }}
                    title="View Details"
                  >
                    <FaEye />
                  </button>
                  <button
                    className="action-btn history"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(`/cctv-camera-history/${camera.deviceId}`);
                    }}
                    title="View History"
                  >
                    <FaHistory />
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CCTVCameraTable;
